import React, { useEffect, useState } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import "./blogdetail.css";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../firebase";

export default function BlogDetailPage() {
  const { urlKey } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchBlog = async () => {
    try {
      const q = query(collection(db, "blogs"), where("urlKey", "==", urlKey));
      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        setBlog(snapshot.docs[0].data());
      } else {
        setBlog(null);
      }
    } catch (error) {
      console.error("Error fetching blog:", error);
      setBlog(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!location.state?.data && urlKey) {
      fetchBlog();
    } else {
      setBlog(location.state?.data);
      setLoading(false);
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [urlKey]);

  if (loading) {
    return (
      <div className="loader-center">
        <div className="loader"></div>
      </div>
    );
  }

  if (!blog) {
    return (
      <div className="notfound-container">
        <h2>Blog Not Found</h2>
        <button onClick={() => navigate("/")} className="back-btn">Back to Blogs</button>
      </div>
    );
  }

  return (
    <div className="blog-container">
      {/* Image */}
      {blog.imageUrl && <img src={blog.imageUrl} alt={blog.title} className="blog-hero-image" />}

      {/* Title */}
      <h1 className="blog-main-title">{blog.title}</h1>

      {/* Date */}
      {blog.createdAt?.seconds && (
        <p className="blog-date">
          {new Date(blog.createdAt.seconds * 1000).toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })}
        </p>
      )}

      {/* Content */}
      <div
        className="blog-main-content"
        dangerouslySetInnerHTML={{ __html: blog.content }}
      />

      <button onClick={() => navigate("/")} className="back-btn">← Back to Blogs</button>
    </div>
  );
}
